import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Global } from './helpers/global';

const routes: Routes = [
  { path: '', redirectTo: Global.RotaSplash, pathMatch: 'full' },
  { path: Global.RotaSplash, loadChildren: () => import('./pages/splash-page/splash-page.module').then(m => m.SplashPagePageModule) },
  { path: Global.RotaTabs, loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule) },
  { path: Global.RotaDetalheProduto, loadChildren: () => import('./pages/tabAbertura/detalhe-produto-page/detalhe-produto-page.module').then(m => m.DetalheProdutoPagePageModule) },
  { path: Global.RotaCarrinho, loadChildren: () => import('./pages/tabCarrinho/carrinho-page/carrinho-page.module').then(m => m.CarrinhoPagePageModule) },
  //{ path: Global.CardapioVirtual, loadChildren: () => import('./pages/tabAbertura/abertura-page/abertura-page.module').then( m => m.AberturaPagePageModule) },
  { path: '**', redirectTo: Global.RotaSplash, pathMatch: 'full' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
